import { render, staticRenderFns } from "./SaveSignatureOrInitials.vue?vue&type=template&id=f0fe74c4&scoped=true&"
import script from "./SaveSignatureOrInitials.vue?vue&type=script&lang=js&"
export * from "./SaveSignatureOrInitials.vue?vue&type=script&lang=js&"
import style0 from "./SaveSignatureOrInitials.vue?vue&type=style&index=0&id=f0fe74c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0fe74c4",
  null
  
)

export default component.exports